const guiColors = {
    'motion-primary': 'hsla(120, 45%, 55%, 1)',
    'motion-primary-transparent': 'hsla(120, 45%, 55%, 0.9)',
    'motion-tertiary': 'hsla(120, 45%, 40%, 1)',

    'looks-secondary': 'hsla(120, 45%, 55%, 1)',
    'looks-transparent': 'hsla(120, 45%, 55%, 0.35)',
    'looks-light-transparent': 'hsla(120, 45%, 55%, 0.15)',
    'looks-secondary-dark': 'hsla(120, 45%, 40%, 1)',

    'extensions-primary': 'hsla(130, 38%, 55%, 1)',
    'extensions-tertiary': 'hsla(130, 38%, 30%, 1)',
    'extensions-transparent': 'hsla(130, 38%, 55%, 0.35)',
    'extensions-light': 'hsla(130, 26%, 75%, 1)',

    'drop-highlight': 'hsl(120, 45%, 68%)'
};

const blockColors = {
    checkboxActiveBackground: 'hsl(120, 45%, 55%)',
    checkboxActiveBorder: 'hsl(120, 45%, 40%)'
};

export {
    guiColors,
    blockColors
};